export default __webpack_public_path__ + "static/media/pic5.a8d3096c.jpg";